<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-7">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChangeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-5" >
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <b-table class="table-custom" @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage" :per-page="paginationLimit">
          <template v-slot:cell(pt_tier)="data">
<!--          <template slot="pt_tier" slot-scope="data">-->
            <p v-if="data.item.pt_tier != 5">T{{data.item.pt_tier}}</p>
            <p v-else>T1</p>
          </template>
<!--          <template slot="total_session_sold" slot-scope="data">-->
          <template v-slot:cell(total_session_sold)="data">
            {{data.item.pt_session_sold_new + data.item.pt_session_sold_renew}}
          </template>
          <template v-slot:cell(status)="data">
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
          </template>
        </b-table>
        <nav class="mt-20 mb-20">
          <b-pagination class="mb-0 justify-content-end" :total-rows="getRowCount(items)" :per-page="paginationLimit" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </div>
    </div>
      <div class="box-mini">
        <div class="p-15">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th colspan="2">Session Sold</th>
                  <th colspan="2">PT Service</th>
                  <th colspan="2">PHA Appointment</th>
                  <th colspan="2">PHA Appointment Show</th>
                  <th colspan="2">MRA Appointment</th>
                  <th colspan="2">MRA Appointment Show</th>
                  <th colspan="2">Session Appointment</th>
                  <th colspan="2">Session Show</th>
                  <th colspan="2">Appointment NoShow</th>
                  <th colspan="2">Appointment Cancel</th>
                  <th colspan="2">Re-Schedule</th>
                  <th colspan="2">Walk-In</th>
                </tr>
                <tr>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                  <th>D</th>
                  <th>M</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{session_sold_daily}}</td>
                  <td>{{session_sold_monthly}}</td>
                  <td>{{pt_service_daily}}</td>
                  <td>{{pt_service_monthly}}</td>
                  <td>{{assessment_appointment_daily - pha_show_daily}}</td>
                  <td>{{assessment_appointment_monthly - pha_show_monthly}}</td>
                  <td>{{pha_show_daily}}</td>
                  <td>{{pha_show_monthly}}</td>
                  <!-- <td>{{assessment_show_daily}}</td>
                  <td>{{assessment_show_monthly}}</td> -->
                  <td>{{reassessment_appointment_daily}}</td>
                  <td>{{reassessment_appointment_monthly}}</td>
                  <td>{{reassessment_show_daily}}</td>
                  <td>{{reassessment_show_monthly}}</td>
                  <td>{{session_appointment_daily}}</td>
                  <td>{{session_appointment_monthly}}</td>
                  <td>{{session_show_daily_2}}</td>
                  <td>{{session_show_monthly_2}}</td>
                  <td>{{pt_appointment_no_show_daily}}</td>
                  <td>{{pt_appointment_no_show_monthly}}</td>
                  <td>{{pt_appointment_cancel_daily}}</td>
                  <td>{{pt_appointment_cancel_monthly}}</td>
                  <td>{{reschedule_daily}}</td>
                  <td>{{reschedule_monthly}}</td>
                  <td>{{walk_in_daily}}</td>
                  <td>{{walk_in_monthly}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="loadingActive == true" class="loading-container">
        <div class="wrap-screen w-100 h-100">
          <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
          <div class="title-loading color-white">Loading...</div>
        </div>
      </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'personal_trainer_id',
          label: 'Employee ID',
          sortable: false
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: false
        },
        {
          key: 'name',
          label: 'PT Name',
          sortable: false
        },
        {
          key: 'personal_training_tier.name',
          label: 'Tier',
          sortable: false
        },
        {
          key: 'session_sold_daily',
          label: 'Session Sold (D)',
          sortable: false
        },
        {
          key: 'session_sold_monthly',
          label: 'Session Sold (M)',
          sortable: false
        },
        {
          key: 'projection_sold',
          label: 'Projection Sold',
          sortable: false
        },
        {
          key: 'pos',
          label: 'POS',
          formatter: (value, key, item) => {
            return item.total_revenue_pos_1 == null || item.total_revenue_pos_2 == 0 ? '0': item.total_revenue_pos_1
          },
          sortable: false
        },
        {
          key: 'pt_service_daily',
          label: 'PT Service (D)',
          sortable: false
        },
        {
          key: 'pt_service_monthly',
          label: 'PT Service (M)',
          sortable: false
        },
        {
          key: 'projection_service2',
          label: 'Projection Service',
          sortable: false
        },
        {
          key: 'assessment_appointment_daily',
          label: 'PHA Appointment (D)',
          sortable: false
        },
        {
          key: 'assessment_appointment_monthly',
          label: 'PHA Appointment (M)',
          sortable: false
        },
        {
          key: 'pha_show_daily',
          label: 'PHA Appointment Show (D)',
          sortable: false
        },
        {
          key: 'pha_show_monthly',
          label: 'PHA Appointment Show (M)',
          sortable: false
        },
        // {
        //   key: 'reassessment_appointment_daily',
        //   label: 'MRA Appointment (D)',
        //   sortable: false
        // },
        // {
        //   key: 'reassessment_appointment_monthly',
        //   label: 'MRA Appointment (M)',
        //   sortable: false
        // },
        // {
        //   key: 'reassessment_show_daily',
        //   label: 'MRA Appointment Show (D)',
        //   sortable: false
        // },
        // {
        //   key: 'reassessment_show_monthly',
        //   label: 'MRA Appointment Show (M)',
        //   sortable: false
        // },
        {
          key: 'session_appointment_daily',
          label: 'Session Appointment (D)',
          sortable: false
        },
        {
          key: 'session_appointment_monthly',
          label: 'Session Appointment (M)',
          sortable: false
        },
        // hapus session show req by adit
        // {
        //   key: 'session_show_daily',
        //   label: 'Session Show (D)',
        //   sortable: false
        // },
        // {
        //   key: 'session_show_monthly',
        //   label: 'Session Show (M)',
        //   sortable: false
        // },
        // {
        //   key: 'pt_appointment_no_show_daily',
        //   label: 'Appointment NoShow (D)',
        //   sortable: false
        // },
        // {
        //   key: 'pt_appointment_no_show_monthly',
        //   label: 'Appointment NoShow (M)',
        //   sortable: false
        // },
        {
          key: 'pt_appointment_cancel_daily',
          label: 'Appointment Cancel (D)',
          sortable: false
        },
        {
          key: 'pt_appointment_cancel_monthly',
          label: 'Appointment Cancel (M)',
          sortable: false
        },
        {
          key: 'reschedule_daily',
          label: 'Re-Schedule (D)',
          sortable: false
        },
        {
          key: 'reschedule_monthly',
          label: 'Re-Schedule (M)',
          sortable: false
        },
        // {
        //   key: 'walk_in_daily',
        //   label: 'Walk-In (D)',
        //   sortable: false
        // },
        // {
        //   key: 'walk_in_monthly',
        //   label: 'Walk-In (M)',
        //   sortable: false
        // },
        {
          key: 'pos',
          label: 'POS',
          formatter: (value, key, item) => {
            return item.total_revenue_pos_1 == null || item.total_revenue_pos_2 == 0 ? '0': item.total_revenue_pos_1
          },
          sortable: false
        },
      ],
      items: [],
      dataBranch: [],
      branch_id: null,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      session_sold_daily : 0,
      getRoleMappingId: Auth.Session.get().paradigm_role_mapping_id,
      session_sold_monthly : 0,
      pt_service_daily : 0,
      pt_service_monthly : 0,
      assessment_appointment_daily : 0,
      assessment_appointment_monthly : 0,
      assessment_show_daily : 0,
      assessment_show_monthly : 0,
      pha_show_daily : 0,
      pha_show_monthly : 0,
      reassessment_appointment_daily : 0,
      reassessment_appointment_monthly : 0,
      reassessment_show_daily : 0,
      reassessment_show_monthly : 0,
      session_appointment_daily : 0,
      session_appointment_monthly : 0,
      session_show_daily : 0,
      session_show_monthly : 0,
      session_show_daily_2 : 0,
      session_show_monthly_2 : 0,
      pt_appointment_no_show_daily: 0,
      pt_appointment_no_show_monthly: 0,
      pt_appointment_cancel_daily: 0,
      pt_appointment_cancel_monthly: 0,
      reschedule_daily: 0,
      reschedule_monthly: 0,
      walk_in_daily: 0,
      walk_in_monthly: 0,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // onChange: this.onChange
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    onChangeDate(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    parseCurrency(value) {
      return value.toLocaleString('id-ID', {maximumFractionDigits:0})
    },
    openPage (event) {
      this.$router.push(event)
    },
    editGallery (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/pt_report/back_to_basic?start_date='+dates[0]+'&end_date='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 7) url += '&pt_id=' + Auth.Session.get().paradigm_id

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'PT Back to Basic (Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    sumData(data,column) {
      let total = data.map(item => item[column]).reduce((prev, next) => prev + next)
      return total
    },
    changeBranch(event) {
      this.fetchData()
      // let dates1 = this.exportDates.split(' to ')
      // let url = 'crm/v1/pt_report/back_to_basic?sorting=' + this.sortBy
      // + '&limit=' + this.paginationLimit
      // + '&sorting_type=' + this.sortType
      // + '&keyword=' + this.searchData
      // + '&start_date=' + dates1[0]
      // + '&end_date=' + dates1[1]

      // if (event != null) {
      //   url += '&branch_id=' + event
      // }

      // axios.get(url).then(response => {
      //   this.items = []
      //   this.items = response.data.data.rows
      //   this.totalPage = response.data.meta.pageCount
      // }).catch(error => {
      //   console.log('error', error)
      // })
    },
    fetchData() {
      this.loadingActive = true
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        if (Auth.Session.get().paradigm_id == 1061857 || Auth.Session.get().paradigm_id == 1061825 || Auth.Session.get().paradigm_id == 1061850 || Auth.Session.get().paradigm_id == 1061816 || Auth.Session.get().paradigm_id == 1061848) {
          let filter = this.dataBranch.filter(item => item.id == Number(Auth.Session.get().paradigm_branch_id))
          this.dataBranch = filter
          this.branch_id = Number(Auth.Session.get().paradigm_branch_id)
        }
      }).catch(error => {
        console.log('error', error)
      })

      let dates1 = this.exportDates.split(' to ')
      if(Auth.Session.get().paradigm_role == 7 && !this.getRoleMappingId.includes(22)) {
        axios.get('crm/v1/pt_report/back_to_basic?personal_trainer_id=' + Auth.Session.get().paradigm_id
          + '&sorting=' + this.sortBy
          + '&sorting_type=' + this.sortType
          + '&keyword=' + this.searchData
          + '&start_date=' + dates1[0]
          + '&end_date=' + dates1[1]
        ).then(response => {
          this.items = []
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else {
        let url = 'crm/v1/pt_report/back_to_basic?sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + dates1[0]
        + '&end_date=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios.get(url).then(response => {
          this.items = []
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          const data = response.data.data.rows
          let session_show_daily_k = 0
          let session_show_monthly_k = 0
          for (let i = 0; i < data.length; i++) {
            console.warn(data[i].session_show_daily, 'Session Daily')

            if (this.items[i].assessment_show_daily !== undefined)
              this.assessment_show_daily += this.items[i].assessment_show_daily

            if (this.items[i].assessment_show_monthly !== undefined)
              this.assessment_show_monthly += this.items[i].assessment_show_monthly

            if (data[i].session_show_daily != undefined && data[i].session_show_daily != 0) {
              session_show_daily_k += data[i].session_show_daily
            }
            if (data[i].session_show_monthly != undefined && data[i].session_show_monthly != 0) {
              session_show_monthly_k += data[i].session_show_monthly
            }

          }

          console.warn(session_show_daily_k, ' Daily')
          console.warn(session_show_monthly_k, ' Monthly')
          // changed
          // this.session_show_daily_2 = session_show_daily_k
          // this.session_show_monthly_2 = session_show_monthly_k
          this.session_show_daily_2 = this.sumData(this.items,"pt_service_daily")
          this.session_show_monthly_2 = this.sumData(this.items,"pt_service_monthly")


          this.session_sold_daily = this.sumData(this.items,"session_sold_daily")
          this.session_sold_monthly = this.sumData(this.items,"session_sold_monthly")

          this.pt_service_daily = this.sumData(this.items,"pt_service_daily")
          this.pt_service_monthly = this.sumData(this.items,"pt_service_monthly")

          this.assessment_appointment_daily = this.sumData(this.items,"assessment_appointment_daily")
          this.assessment_appointment_monthly = this.sumData(this.items,"assessment_appointment_monthly")

          this.reassessment_appointment_daily = this.sumData(this.items,"reassessment_appointment_daily")
          this.reassessment_appointment_monthly = this.sumData(this.items,"reassessment_appointment_monthly")

          this.reassessment_show_daily = this.sumData(this.items,"reassessment_show_daily")
          this.reassessment_show_monthly = this.sumData(this.items,"reassessment_show_monthly")

          this.session_appointment_daily = this.sumData(this.items,"session_appointment_daily")
          this.session_appointment_monthly = this.sumData(this.items,"session_appointment_monthly")

          this.pt_appointment_no_show_daily = this.sumData(this.items,"pt_appointment_no_show_daily")
          this.pt_appointment_no_show_monthly = this.sumData(this.items,"pt_appointment_no_show_monthly")

          this.pt_appointment_cancel_daily = this.sumData(this.items,"pt_appointment_cancel_daily")
          this.pt_appointment_cancel_monthly = this.sumData(this.items,"pt_appointment_cancel_monthly")

          this.reschedule_daily = this.sumData(this.items,"reschedule_daily")
          this.reschedule_monthly = this.sumData(this.items,"reschedule_monthly")

          this.walk_in_daily = this.sumData(this.items,"walk_in_daily")
          this.walk_in_monthly = this.sumData(this.items,"walk_in_monthly")

          this.pha_show_daily = this.sumData(this.items,"pha_show_daily")
          this.pha_show_monthly = this.sumData(this.items,"pha_show_monthly")

          this.loadingActive = false

        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      }
    }
  },
  created () {
    if (this.getRoleMappingId.includes(22)) {
      this.branch_id = Auth.Session.get().paradigm_branch_id
    }
    this.fetchData()
  }
}
</script>

<style>
</style>
